import React from 'react';
import * as LucideIcons from 'lucide-react';

interface SectionHeaderProps {
  title: string;
  iconName?: keyof typeof LucideIcons;
  badge?: string;
  description?: string;
  variant?: 'art' | 'stream' | 'neutral';
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, iconName, badge, description, variant = 'neutral' }) => {
  const Icon = iconName ? (LucideIcons[iconName] as React.ElementType) : null;

  const variantColors = {
    art: 'text-amber-500 bg-amber-500/10 border-amber-500/20',
    stream: 'text-purple-500 bg-purple-500/10 border-purple-500/20',
    neutral: 'text-indigo-500 bg-indigo-500/10 border-indigo-500/20',
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        {badge && (
          <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border ${variantColors[variant]}`}>
            {Icon && <Icon className="w-3.5 h-3.5" />}
            <span>{badge}</span>
          </div>
        )}
      </div>
      <h2 className="text-2xl font-bold font-heading text-slate-900 dark:text-white tracking-tight flex items-center gap-2">
        {!badge && Icon && <Icon className={`w-6 h-6 ${variantColors[variant].split(' ')[0]}`} />}
        {title}
      </h2>
      {description && <p className="text-sm text-slate-500 dark:text-slate-400">{description}</p>}
    </div>
  );
};

export default SectionHeader;
